import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const Ctx = createContext(null);

/* Part 7 — global Admin Control Center state. Visible only to admins; the
 * server enforces every permission independently of this UI gate. */
export function ControlCenterProvider({ children }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("member");
  const [target, setTarget] = useState(null); // {type, id, handle?, label?}
  const [me, setMe] = useState(null);
  const [liveRoomOpen, setLiveRoomOpen] = useState(false);
  const isAdmin = !!user && user.role === "admin" && user.admin_scope !== "technical";

  const openCC = useCallback((opts = {}) => {
    if (opts.tab) setTab(opts.tab);
    if (opts.target !== undefined) setTarget(opts.target);
    setOpen(true);
  }, []);

  useEffect(() => {
    if (!isAdmin) return undefined;
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === "K" || e.key === "k")) {
        e.preventDefault();
        setOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isAdmin]);

  const value = useMemo(() => ({
    isAdmin, open, setOpen, tab, setTab, target, setTarget, openCC, me, setMe, liveRoomOpen, setLiveRoomOpen,
    close: () => setOpen(false),
  }), [isAdmin, open, tab, target, openCC, me, liveRoomOpen]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useControlCenter() {
  return useContext(Ctx) || { isAdmin: false, open: false, openCC: () => {}, close: () => {} };
}
